/* EtteNaturals design layer script. Loaded deferred by sections/ette-foundation.liquid.
   Entrance motion is CSS-only (see ette.css, Motion). Phase 3 adds the sticky product bar here. */
(() => {
  // Carousel rows (.ette-cards__row, .ette-explore__list): prev/next buttons and arrow keys.
  // Delegated on document so rows re-rendered by the theme editor keep working.
  const ROWS = '.ette-cards__row, .ette-explore__list';

  const step = (row) => {
    const item = row.firstElementChild;
    const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
    return item ? item.getBoundingClientRect().width + gap : row.clientWidth * 0.8;
  };

  const sync = (row) => {
    const nav = row.parentElement.querySelector('.ette-cards__nav');
    if (!nav) return;
    const max = row.scrollWidth - row.clientWidth;
    nav.hidden = max < 8;
    const [prev, next] = nav.querySelectorAll('[data-ette-scroll]');
    if (prev) prev.disabled = row.scrollLeft < 8;
    if (next) next.disabled = row.scrollLeft > max - 8;
  };

  const move = (row, dir) => {
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    row.scrollBy({ left: dir * step(row), behavior: smooth ? 'smooth' : 'auto' });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ette-scroll]');
    if (!button) return;
    const row = button.closest('.ette-cards')?.querySelector(ROWS);
    if (row) move(row, Number(button.dataset.etteScroll));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    const row = event.target.closest?.(ROWS);
    if (!row || event.target !== row) return; // only when the row itself has focus
    event.preventDefault();
    move(row, event.key === 'ArrowRight' ? 1 : -1);
  });

  document.addEventListener('scroll', (event) => {
    if (event.target instanceof Element && event.target.matches(ROWS)) sync(event.target);
  }, { capture: true, passive: true });

  const init = () => document.querySelectorAll(ROWS).forEach(sync);
  init();
  window.addEventListener('resize', init, { passive: true });
  document.addEventListener('shopify:section:load', init);
})();
